export const INICIO_TRAMITE = "/IniciarTramite";
export const CUIT_SELECCIONADO = "/CuitSeleccionado";
export const CONFIRMAR_TOKEN_SMS = "/ConfirmarTokenSms";
export const PRE_INFO_TARJETAS = "/PreInfoTarjetas";
export const SAVE_INFO_TARJETAS = "/SaveInfoTarjetas";
export const PRE_INFO_PERSONAL = "/PreInfoPersonal";
export const SAVE_INFO_PERSONAL = "/SaveInfoPersonal";
export const CONFIRMAR_TOKEN_EMAIL = "/ConfirmarTokenEmail";
export const RE_ENVIO_TOKEN = "/ReEnvioToken";
export const REENVIAR_LINK_REVISA_TU_TELEFONO = "/ReenviarLinkRevisaTuTelefono";
export const SAVE_ONLINE_LOAN = "/SaveOnlineLoan";
export const TERMINOS_Y_CONDICIONES = "/TerminosYCondiciones";
export const GET_PROVINCIAS = "/GetProvincias"
export const GET_PROVINCIA_DESC= "/GetProvinciaDesc"; 
export const GET_LOCALIDADES_BY_PROVINCIAS= "/GetLocalidadByProvincia";
export const GET_OBTENER_CP_DE_LOCALIDAD = "/GetCPDeUnaLocalidad";
export const GET_PRODUCTOS_IMAGENES_BASE64 = "/PreIniciar";